var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')
var ReUpText = require('./ReUpText');

var {
  AppRegistry,
  View,
  Text,
  StyleSheet,
} = ReactNative;

var ShadowView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      layout : {width:0,height:0},
      appManager : {},
      text : null,
      shouldDrop : false,
    }
  },

  getInitialState : function()
  {
    return {
      shadowOpacity : new Animated.Value(0),
    }
  },

  _didFadeIn : false,
  fadeIn : function()
  {
    if( this._didFadeIn ) return;

    this._didFadeIn = true;
    var thisThing = this;
    Animated.timing(
     thisThing.state.shadowOpacity,
     {toValue: 1,
     duration:100},
    ).start(function()
    {});
  },

  fadeOut : function()
  {
    if( !this._didFadeIn ) return;

    this._didFadeIn = false;
    var thisThing = this;
    Animated.timing(
     thisThing.state.shadowOpacity,
     {toValue: 0,
     duration:100},
    ).start(function()
    {});
  },

  render: function()
  {
    var navSpacerLineColor = this.props.appManager.getColorForKey("HeaderTitleColor",0.1);
    var navSpacerBGColor = this.props.appManager.getColorForKey("HeaderColor", 0.2);
    var style = this.props.style;
    if( typeof style === 'undefined' ) style = {};

    if( this.props.shouldDrop )
    {
      var navHeaderColor = this.props.appManager.getColorForKey("HeaderColor");
      var primaryBorderColor = this.props.appManager.getColorForKey("ButtonPrimaryBorderColor");
      return (
        <Animated.View style={[style, {overflow:'hidden', height:4, opacity:this.state.shadowOpacity}]}>
          <View style={{position:'absolute', left:0, right:0, bottom:5, backgroundColor:navHeaderColor,  shadowOffset:{width:0,height:4}, shadowOpacity:.6, shadowRadius:1, height:4, shadowColor:primaryBorderColor}} />
        </Animated.View>
      )
    }
    else if( this.props.text == null )
    {
      return (
        <View style={[{height:1,backgroundColor:navSpacerLineColor,width:this.props.layout.width},style]}>
          <View style={{flex:1, backgroundColor:navSpacerBGColor}} />
        </View>
      );
    }
    else
    {
      var generalTitleColor = this.props.appManager.getColorForKey("GeneralTitleColor");
      return (
        <View style={style}>
          <View style={{flexDirection:'row', alignItems:'center', padding:10, paddingRight:20, paddingLeft:20}}>
            <View style={[{height:1,backgroundColor:navSpacerLineColor,flex:1},style]}>
              <View style={{flex:1, backgroundColor:navSpacerBGColor}} />
            </View>
            <ReUpText appManager={this.props.appManager} style={{marginLeft:10, marginRight:10, color:generalTitleColor}}>{this.props.text}</ReUpText>
            <View style={[{height:1,backgroundColor:navSpacerLineColor,flex:1},style]}>
              <View style={{flex:1, backgroundColor:navSpacerBGColor}} />
            </View>
          </View>
        </View>
      );
    }
  }
});

module.exports = ShadowView;
